import { Stack } from "expo-router";
import { Text, View } from "@src/components";

/**
 * Native fallback required by Expo Router beside `announcements.web.tsx`.
 * Announcements are a web-only support tool with no native entry point.
 */
export default function AnnouncementsNativeScreen() {
  return (
    <>
      <Stack.Screen options={{ title: "Announcements" }} />
      <View flex={1} alignItems="center" justifyContent="center" padding="3xl" gap="md">
        <Text textStyle="sm/semibold" color="text" textAlign="center">
          Announcements are only available on the web client.
        </Text>
      </View>
    </>
  );
}
